import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'
import { type Company, companyBySlugQueryOptions } from '@/entities/company'
import { ApiError } from '@/shared/api'
import { toast } from '@/shared/ui/toast'
import { EditCompanyDialog } from './edit-company-dialog'

interface EditCompanyDialogLazyProps {
  // Строка справочника несёт slug, но не полную карточку — тянем её по slug.
  slug: string
  open: boolean
  onClose: () => void
  onSaved?: (company: Company) => void
}

// Ленивая обёртка для справочника компаний: диалог правки хочет полную Company
// (реквизиты/контакты/версия), а строка списка — тонкая. Дотягиваем by-slug.
export function EditCompanyDialogLazy({
  slug,
  open,
  onClose,
  onSaved,
}: EditCompanyDialogLazyProps) {
  const q = useQuery({ ...companyBySlugQueryOptions(slug), enabled: open })

  useEffect(() => {
    if (!q.error) return
    toast.error(q.error instanceof ApiError ? q.error.message : 'Не удалось загрузить компанию')
    onClose()
  }, [q.error, onClose])

  if (!open || !q.data) return null
  return (
    <EditCompanyDialog company={q.data} open onClose={onClose} {...(onSaved ? { onSaved } : {})} />
  )
}
